import React, { useState } from 'react'

const MapeTable = ({ mapeData }) => {
    console.log(mapeData);

    const [selectedCity, setSelectedCity] = useState("");
    const [filteredData, setFilteredData] = useState([]);


    const handleCityChange = (event) => {
        const city = event.target.value;
        setSelectedCity(city);

        // Filter data based on city
        const cityData = mapeData.find((item) => item.city === city);
        if (cityData) {
            const tableData = cityData.data.map((entry) => ({
                sku: entry.sku,
                model: entry.data[0].model,
                param: entry.data[0].param,
                seasonal: entry.data[0].seasonal,
                trend: entry.data[0].trend,
                train_mape: entry.data[0].train_mape,
                test_mape: entry.data[0].test_mape,
            }));
            setFilteredData(tableData);
        } else {
            setFilteredData([]);
        }
    };

    return (
        <>
            <h2 style={{ margin: "5vh 0 5vh 0" }} className="text-3xl font-bold mb-4 text-center">Mape Table</h2>
            <div style={{ marginTop: "5vh 0 5vh 0" }} className="mycontainer manage-workflow-box">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="w-full">
                                {/* City Selection Dropdown */}
                                <div className="my-4">
                                    <label htmlFor="city-select" className="mr-2">
                                        Select City:
                                    </label>
                                    <select
                                        id="city-select"
                                        value={selectedCity}
                                        onChange={handleCityChange}
                                        className="p-2 border rounded"
                                    >
                                        <option value="">-- Select City --</option>
                                        {mapeData.map((item) => (
                                            <option key={item.city} value={item.city}>
                                                {item.city}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <table className="table dataselectiontable table-bordered">
                                    <thead>
                                        <tr className="bg-blue-900 text-white">
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">SKU</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Model</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Param</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Seasonal</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Trend</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Train MAPE</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Test MAPE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData && filteredData.length > 0 ? (
                                            filteredData.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="border border-gray-200 p-2">{row.sku}</td>
                                                    <td className="border border-gray-200 p-2">{row.model}</td>
                                                    <td className="border border-gray-200 p-2">{row.param}</td>
                                                    <td className="border border-gray-200 p-2">{row.seasonal}</td>
                                                    <td className="border border-gray-200 p-2">{row.trend}</td>
                                                    <td className="border border-gray-200 p-2">{row.train_mape.toFixed(2)}</td>
                                                    <td className="border border-gray-200 p-2">{row.test_mape.toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center p-4">
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MapeTable